import React from 'react';

interface ScrollableBoxProps {}

export const ScrollableBox: React.FC<ScrollableBoxProps> = ({ children }) => {
  return (
    <div className="flex flex-wrap -m-1 wrapper-fixed-height">{children}</div>
  );
};

export default ScrollableBox;
